<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header" style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393F;
    ">
    <mat-card-title class="mcd-card-title">View All Standards</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row">
      <div class="col filter-panel">
        <app-view-all-standards-filter [isFromLocation]="isFromLocation" (messageEvent)="receivedFilteration($event)"
          (searchApplied)="onSearchFromChild($event)" (exportListFilter)="handleExport($event)"
          (countryListFilter)="handleCountryList($event)" [searchKeyFromParent]="searchKey"
          [isExporting]="isDownloading"></app-view-all-standards-filter>
      </div>
      <div class="collpsible-panel">
        <button class="btn-collapse" mat-icon-button aria-label="Collapse">
          <i class="material-icons"> expand_less </i>
        </button>
        <button class="btn-expand" mat-icon-button aria-label="Expand">
          <mat-icon>expand_more</mat-icon>
        </button>
      </div>
    </div>

    <div class="table-wrapper">
      <!-- <div class="row">
        <div class="text-left" width="140">
          <mat-form-field>
            <input
              matInput
              placeholder="Search by Title or Description"
              value="{{ searchKey }}"
              (keyup.enter)="addSearchKey(key)"
              name="search"
              #key
            />
            <button
              mat-button
              *ngIf="searchKey"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="searchKey = ''; addSearchKey(searchKey)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div> -->

      <table matSort (matSortChange)="sortData($event)"
        *ngIf="standardsTableRows.length > 0 && !getAppliedFilters().includes(4)" class="table nrbes-grid">
        <thead class="thead-light">
          <tr>
            <th mat-sort-header="title" width="280" scope="col">
              <div class="title-cell-wrapper">
                <mat-checkbox *ngIf="getSelectableRowsOnPage().length > 0" color="primary"
                  [checked]="isAllOnPageSelected()" [indeterminate]="isSomeOnPageSelected()"
                  (click)="$event.stopPropagation()" (change)="selectAllOnPageChange($event)"></mat-checkbox>
                <span>Standard Title</span>
              </div>
            </th>
            <th mat-sort-header="category" width="70" scope="col-2">
              Type
            </th>
            <th scope="col" width="220">Location</th>

            <th mat-sort-header="category" width="120" scope="col-2">
              Category
            </th>
            <th scope="col-2" width="35%" mat-sort-header="desc">
              Description
            </th>
            <th scope="col" width="120" *ngIf="shouldShowMarketStandardsCountryColumn()">
              Country
            </th>
            <!--<th scope="col" width="170">Type</th>-->
            <th scope="col" width="80" *ngIf="shouldShowStandardsRowActions()"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of standardsTableRows" (click)="onTableRowSelected(item)">
            <td class="title-cell" style="font-weight: 500; color: #3949a3; font-size: 14px;padding: 12px;">
              <div class="title-cell-wrapper">
                <mat-checkbox *ngIf="showStandardSelectionCheckbox(item)" color="primary"
                  [checked]="isSelected(getRowSelectionKey(item))" (click)="$event.stopPropagation()"
                  (change)="onCheckboxChange($event, getRowSelectionKey(item))"></mat-checkbox>
                <span class="standard-title-text">{{ item.title }}</span>
              </div>
            </td>
            <td>
              <span *ngIf="isMarketStandardsTab()" class="standard-type-label">{{
                getStandardTypeLabel(item.standardTypeId)
                }}</span>
              <img *ngIf="!isMarketStandardsTab()" [src]="getStandardIcon(item.standardTypeId)" height="16" width="16"
                alt="" />
            </td>

            <td class="location-cell">{{ item.locationText }}</td>
            <td class="category-cell">{{ item.categoryName }}</td>
            <td class="description">
              <span title="{{ item.newRestaurantDescription || item.description }}" class="description">
                {{ getTableRowDescription(item) }}
              </span>
            </td>

            <td *ngIf="shouldShowMarketStandardsCountryColumn()">
              {{ item.countryName }}
            </td>

            <!--<td class="hide-sm"> {{item.standardType.name}}</td>-->
            <td *ngIf="shouldShowStandardsRowActions() && !item.isNrbesRow">
              <div class="grid-actions hide-sm" *ngIf="selectedRowsForExport.length < 2">
                <button style="border: none; background: none" (click)="togglePopup($event, item.standard)">
                  <img src="/assets/images/menu-dots 2.svg" />
                </button>

                <div class="action-popup editDeletModal" *ngIf="activePopupId === item.id">
                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="onEditHover"
                    (click)="onEdit(item)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: rgba(63, 81, 181, 1);
                        font-size: 14px;
                        text-align: left;
                        display: block;
                        width: 100%;
                      " routerLinkActive="active" title="Edit" href="javascript:void(0);">
                      <span><img src="/assets/images/d-edit 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px" /></span>
                      <span>Edit</span>
                    </a>
                  </div>

                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="onEditHover"
                    *ngIf="showAddExceptionAction(item)" (click)="addAddendumFromRow(item, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: #3f51b5;
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      " routerLinkActive="active" title="Add" href="javascript:void(0);">
                      <span><img src="/assets/images/file-new 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px" /></span>
                      <span>Add Exception</span>
                    </a>
                  </div>

                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="onEditHover"
                    *ngIf="showGoToExceptionAction(item)" (click)="goToAddendumFromRow(item, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: #3f51b5;
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      " href="javascript:void(0);">
                      <span><img src="/assets/images/file-new 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px" /></span>
                      <span>Go to Exception</span>
                    </a>
                  </div>

                  <hr style="margin: 2px; border: 1px solid #dde1e6" />

                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="oDeleteHover"
                    (click)="openDeleteModal(item.standard, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: rgba(222, 52, 40, 1);
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      " routerLinkActive="active" title="clear">
                      <span><img src="/assets/images/bin.svg" style="margin-bottom: 4px; margin-right: 5px" /></span>

                      <span>Delete</span>
                    </a>
                  </div>
                </div>
              </div>
              <!-- <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="openDeleteModal(item, $event)"
                    routerLinkActive="active"
                    title="clear"
                    ><i class="material-icons"> clear </i></a
                  >
                </div>
                <div class="col-6">
                  <a
                    class="action-controls"
                    (click)="onEdit(item.id)"
                    routerLinkActive="active"
                    title="Edit"
                    href="javascript:void(0);"
                    ><i class="material-icons"> create </i></a
                  >
                </div> -->

              <a (click)="actionMenuOpen($event)" class="mcd-more-btn show-sm" [matMenuTriggerFor]="menu"
                href="javascript:void(0);">
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button mat-menu-item (click)="onEdit(item)">Edit</button>
                  <button mat-menu-item *ngIf="showAddExceptionAction(item)" (click)="addAddendumFromRow(item, $event)">
                    Add Exception
                  </button>
                  <button mat-menu-item *ngIf="showGoToExceptionAction(item)"
                    (click)="goToAddendumFromRow(item, $event)">
                    Go to Exception
                  </button>
                  <button mat-menu-item (click)="closeMatMenuAndOpenDeleteModal(item.standard, $event)">
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
      <table matSort (matSortChange)="sortEquipment($event)" class="table nrbes-grid"
        *ngIf="getAppliedFilters().includes(4) && !isMarketStandardsTab()">
        <thead class="thead-light">
          <tr>
            <th mat-sort-header="equipmentType" width="110" scope="col-2">
              Equipment Type
            </th>
            <th mat-sort-header="supplier" width="110" scope="col-2">
              Supplier
            </th>
            <th mat-sort-header="title" scope="col-4" width="20%">Title</th>
            <th mat-sort-header="model" scope="col" width="110">Model</th>
            <th mat-sort-header="equipmentClass" scope="col" width="110">
              Equipment Class
            </th>
            <th scope="col-4" width="10%">Location Type</th>
            <th scope="col-4" width="15%">Obsolete Date</th>
            <th scope="col" width="80" *ngIf="isGlobalAdmin()">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of grses" (click)="rowSelected(item)">
            <td class="description" style="font-weight: bold">
              {{ item.equipmentStandard.equipmentType.name }}
            </td>
            <td class="description">
              {{ item.equipmentStandard.supplier.name }}
            </td>
            <td class="title-cell">{{ item.title }}</td>
            <td class="description">{{ item.equipmentStandard.model }}</td>
            <td class="description">
              {{ item.equipmentStandard.equipmentClassType.name }}
            </td>
            <td class="location-cell">{{ getLocationNames(item) }}</td>
            <td class="category-cell" *ngIf="
                item?.equipmentStandard?.obsoleteDate != null;
                else elseBlock
              ">
              Obsolete Date -
              {{ item.equipmentStandard.obsoleteDate | date: "MM.dd.yyyy" }}
            </td>
            <ng-template #elseBlock>
              <td class="category-cell">Obsolete Date Not Set</td>
            </ng-template>

            <td *ngIf="isGlobalAdmin()">
              <div class="row grid-actions hide-sm">
                <div class="col-6">
                  <a class="action-controls" (click)="openDeletePopup(item, $event)" routerLinkActive="active"
                    title="clear"><i class="material-icons"> clear </i></a>
                </div>
                <div class="col-6">
                  <a class="action-controls" (click)="onEditEquipment(item.id)" routerLinkActive="active" title="Edit"
                    href="javascript:void(0);"><i class="material-icons"> create </i></a>
                </div>
              </div>

              <a (click)="actionMenuOpen($event)" class="mcd-more-btn show-sm" [matMenuTriggerFor]="menu"
                href="javascript:void(0);">
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button mat-menu-item (click)="onEditEquipment(item.id)">
                    Edit
                  </button>
                  <button mat-menu-item (click)="closeMatMenuAndOpenDeleteModal(item, $event)">
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        " *ngIf="standardsTableRows.length > 0 || (getAppliedFilters().includes(4) && grses.length > 0)">
        <div>
          <div>
            <mat-form-field>
              <mat-select style="
                  padding: 8px 16px;
                  border: 1px solid #DDE1E6;
                  border-radius: 4px;
                  background: #F8FAFB;
                " [value]="pageSize" name="nOfRows" #items (selectionChange)="selectedItemsPerPageChange(items)">
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- <div class="col-6 float-right">
          
          <a
            *ngIf="grses.length > 0 && isDownloading"
            class="float-right"
            disabled
            style="color: #0b59ca; text-decoration: none; cursor: pointer"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Downloading, Please wait...
          </a>
          <a
            *ngIf="grses.length > 0 && !isDownloading"
            class="float-right"
            href="javascript:void(0);"
            (click)="downloadExcel()"
            style="
              margin-top: 10px;
              color: #0b59ca;
              text-decoration: none;
              cursor: pointer;
            "
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="margin-bottom: 2px; margin-right: 2px"
            >
              <path
                d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                stroke="#3C74E0"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Download
          </a>
        
        </div> -->

        <div>
          <div>
            <ngb-pagination class="float-right" [(page)]="page" [pageSize]="pageSize" [maxSize]="4" [rotate]="true"
              [ellipses]="true" [collectionSize]="collectionSize" (pageChange)="onPageChange($event)"></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button class="prevButton" [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f',
            }" (click)="goToPreviousPage()">
            <img src="/assets/images/leftarrow.svg" />

            Previous
          </button>
          <button class="nextButton" [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f',
            }" (click)="goToNextPage()">
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="
        standardsTableRows.length == 0 &&
        mergedTableRows.length == 0 &&
        !searchKey &&
        !getAppliedFilters().includes(4)
      " class="noResults">
      {{
      isMarketStandardsTab()
      ? "Sorry you do not have any market standards."
      : "Sorry you do not have any minimum standard."
      }}
    </div>
    <div *ngIf="
        standardsTableRows.length == 0 &&
        mergedTableRows.length == 0 &&
        searchKey &&
        !getAppliedFilters().includes(4)
      " class="search-empty-state">
      <img
        src="/assets/images/GRBES-List.svg"
        alt=""
        class="search-empty-icon"
      />
      <h4 class="search-empty-title">No results found</h4>
      <p class="search-empty-subtitle">
        Try a different keyword or refine your search to find what you're
        looking for.
      </p>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>